(function (Spinner, app) {
	var spinnerConfig = {
		lines: 50, // The number of lines to draw
		length: 0.05, // The length of each line
		width: 2, // The line thickness
		radius: 14, // The radius of the inner circle
		rotate: 0, // The rotation offset
		color: '#bbb', // #rgb or #rrggbb
		speed: 1.4, // Rounds per second
		trail: 80, // Afterglow percentage
		shadow: false, // Whether to render a shadow
		hwaccel: false, // Whether to use hardware acceleration
		className: 'spinner', // The CSS class to assign to the spinner
		zIndex: 2e9, // The z-index (defaults to 2000000000)
		top: '50%', // Top position relative to parent in px
		left: '50%', // Left position relative to parent in px
		position: 'absolute'
	};

	var smallSpinnerConfig = {
		lines: 50, // The number of lines to draw
		length: 0.05, // The length of each line
		width: 2, // The line thickness
		radius: 7, // The radius of the inner circle
		rotate: 0, // The rotation offset
		color: '#aaa', // #rgb or #rrggbb
		speed: 1.4, // Rounds per second
		trail: 60, // Afterglow percentage
		shadow: false, // Whether to render a shadow
		hwaccel: false, // Whether to use hardware acceleration
		className: 'spinner', // The CSS class to assign to the spinner
		zIndex: 2e9, // The z-index (defaults to 2000000000)
		top: '50%', // Top position relative to parent in px
		left: '50%', // Left position relative to parent in px
		position: 'absolute'
	};

	app.spinner = {
		getSpinner: function() {
			return new Spinner(spinnerConfig);
		},
		getSmallSpinner: function() {
			return new Spinner(smallSpinnerConfig);
		}
	};

})(Spinner, app)